export const getActiveComposition = () => {
    const comp = app.project && app.project.activeItem && app.project.activeItem instanceof CompItem ? app.project.activeItem : null
    if (!comp) {
      throw new Error('Please select a composition.')
    }
    return comp
  }